import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Service} from "../../models/service";
import {ServiceService} from "../../services/service.service";

@Injectable()
export class ServiceResolve implements Resolve<Service> {
    constructor(private serviceService: ServiceService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Service> {
        return this.serviceService.getById(route.params.id);
    }
}
